import { inject, makeStateKey, TransferState } from "@angular/core";
import { ResolveFn} from "@angular/router";
import {TServiceResult} from "@shared/helper/t-service-result";
import {IClubPreviewModel} from "@app/pages/clubs/models/club-preview-model";
import { of} from "rxjs";
import {switchMap} from "rxjs/operators";
import {LocalRepository} from "@shared/helper/local-repository";
import {ClubAggregatorService} from "@app/pages/clubs/services/club-aggregator.service";

export const STATE_KEY_CLUB_INTRO = makeStateKey<TServiceResult<IClubPreviewModel>>('STATE_KEY_CLUB_INTRO');


export const ClubIntroResolver: ResolveFn<TServiceResult<IClubPreviewModel>> = (route, state) => {
  const _localRepository: LocalRepository = inject(LocalRepository);
  const serverState: TransferState = inject(TransferState);
  const clubAggregatorService: ClubAggregatorService = inject(ClubAggregatorService);
  if (!_localRepository.IsInBrowser) {
    return clubAggregatorService.getClubPreviewById(route.paramMap.get('id')!)
        .pipe(switchMap(res => {
          serverState.set(STATE_KEY_CLUB_INTRO, res);
          return of(res);
        }));
  }

  return of(serverState.get(STATE_KEY_CLUB_INTRO, TServiceResult.fromFailure(null)));
}
